import React from 'react';

const IconLupaDisabled = ({ fill }) => (
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" >
<path d="M8.80624 7.74566C9.39675 6.93927 9.74996 5.94877 9.74996 4.87499C9.74996 2.18701 7.56294 0 4.87497 0C2.18699 0 0 2.18701 0 4.87499C0 7.56297 2.18701 9.74998 4.87499 9.74998C5.94877 9.74998 6.93936 9.39672 7.74575 8.80622L10.4092 11.4697C10.7021 11.7625 11.1769 11.7625 11.4697 11.4697C11.7626 11.1768 11.7626 10.702 11.4697 10.4091L8.80624 7.74566ZM4.87499 8.24997C3.01391 8.24997 1.50001 6.73607 1.50001 4.87499C1.50001 3.01391 3.01391 1.50001 4.87499 1.50001C6.73607 1.50001 8.24997 3.01391 8.24997 4.87499C8.24997 6.73607 6.73605 8.24997 4.87499 8.24997Z" fill={fill}/>
</svg>
);


export default IconLupaDisabled;
